// 전체 다크 모드 쿠키 이름 — 브라우저 코드(theme.ts)와 빌드 설정(vite.ts) 둘 다 쓰므로 의존성 없는 파일에 둔다.
export const THEME_COOKIE = "thuthi_theme"
